import { useRef, useState, useCallback } from "react";

export function BeforeAfterSlider({ before, after }: { before: string; after: string }) {
  const [pct, setPct] = useState(50);
  const ref = useRef<HTMLDivElement>(null);

  const update = useCallback((clientX: number) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPct((x / rect.width) * 100);
  }, []);

  return (
    <div
      ref={ref}
      className="relative w-full aspect-video select-none overflow-hidden rounded-2xl bg-zinc-900 border border-white/10 cursor-ew-resize"
      onMouseMove={(e) => e.buttons === 1 && update(e.clientX)}
      onMouseDown={(e) => update(e.clientX)}
      onTouchMove={(e) => update(e.touches[0]?.clientX ?? 0)}
    >
      <img src={after} alt="After" loading="lazy" decoding="async" className="absolute inset-0 size-full object-contain" draggable={false} />
      <div className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${pct}%` }}>
        <img src={before} alt="Before" loading="lazy" decoding="async" className="absolute inset-0 h-full object-contain"
             style={{ width: ref.current?.clientWidth ?? '100%' }} draggable={false} />
      </div>
      <div className="absolute top-0 bottom-0 w-px bg-white shadow-[0_0_10px_rgba(0,0,0,0.5)]" style={{ left: `${pct}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 size-10 rounded-full bg-white text-zinc-950 grid place-items-center text-xs font-semibold shadow-xl">
          ↔
        </div>
      </div>
      <div className="absolute top-3 left-3 px-2 py-1 rounded-full bg-black/60 text-white text-[10px] uppercase tracking-wider">Before</div>
      <div className="absolute top-3 right-3 px-2 py-1 rounded-full bg-amber-300 text-zinc-950 text-[10px] uppercase tracking-wider font-bold">After</div>
    </div>
  );
}